import { render, staticRenderFns } from "./TwAddContractDrawer.vue?vue&type=template&id=4b6bacb8&scoped=true&"
import script from "./TwAddContractDrawer.vue?vue&type=script&lang=js&"
export * from "./TwAddContractDrawer.vue?vue&type=script&lang=js&"
import style0 from "./TwAddContractDrawer.vue?vue&type=style&index=0&id=4b6bacb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6bacb8",
  null
  
)

export default component.exports